import axios from '@/axiosInstance.ts'
import axiosNode from '@/axiosInstanceNode.ts'
import {ResponseType, ResponseTypeParam} from '@/types.ts'
import {ChatbotAssignmentTaskStatusArray} from '@features/chatbot/types.ts'

/*Get assignment*/
interface HttpGetAssignmentOptions {
    urlParams: {assignmentCode: number}
    params: ResponseTypeParam
}
export const httpGetAssignment = ({urlParams, params}: HttpGetAssignmentOptions) =>
    axios.get(`assignments/${urlParams.assignmentCode}`, {params})

/*Accept assignment*/
interface HttpAcceptAssignmentOptions {
    urlParams: {assignmentId: number}
    params: ResponseTypeParam & {
        selectedDate?: string
        timezone?: string
    }
}
export const httpAcceptAssignment = ({urlParams, params}: HttpAcceptAssignmentOptions) =>
    axios.get(`assignment/${urlParams.assignmentId}/accept`, {params})

/*Decline assignment*/
export interface HttpDeclineAssignmentOptions {
    payload: {
        notes: string
        reason_id: number
    }
    urlParams: {assignmentId: number}
    params: ResponseTypeParam
}
export const httpDeclineAssignment = ({urlParams, params, payload}: HttpDeclineAssignmentOptions) =>
    axios.post(`assignment/${urlParams.assignmentId}/decline`, payload, {params})

/*Get decline reasons*/
export const httpGetDeclineReasons = () => axios.get('/reasons/decline')

/*Schedule assignment*/
export interface HttpScheduleAssignmentOptions {
    payload: {
        date: string
        timezone: string
    }
    params: ResponseTypeParam
    urlParams: {assignmentId: number}
}
export const httpScheduleAssignment = ({urlParams, payload, params}: HttpScheduleAssignmentOptions) =>
    axios.post(`/assignment/${urlParams.assignmentId}/set-date`, payload, {params})

/*Get unresponsive host reasons*/
export const httpGetUnresponsiveHostReasons = () => axios.get('/reasons/host-unresponsive')

/*Get spaces*/
interface HttpGetSpaces {
    urlParams: {assignmentId: number}
    params: ResponseTypeParam
}

export const httpGetSpaces = ({urlParams, params}: HttpGetSpaces) =>
    axios.get(`/assignment/${urlParams.assignmentId}/spaces`, {params})

/*Update personal notes*/
export interface HttpUpdatePersonalNotesOptions {
    params: ResponseTypeParam
    urlParams: {assignmentId: number}
    payload: {notes: string}
}
export const httpUpdatePersonalNotes = ({urlParams, params, payload}: HttpUpdatePersonalNotesOptions) =>
    axios.post(`/assignments/${urlParams.assignmentId}/notes`, payload, {params})

/*Unschedule shooting*/
interface HttpUnscheduleAssignment {
    urlParams: {assignmentId: number}
    params: ResponseTypeParam
}

export const httpUnscheduleAssignment = ({urlParams, params}: HttpUnscheduleAssignment) =>
    axios.get(`/assignment/${urlParams.assignmentId}/unschedule-task`, {params})

/*Submit assets to Airbnb*/
export interface HttpSubmitToAirbnbOptions {
    params: {photographer_notes: string} & ResponseTypeParam
    urlParams: {assignmentId: number}
}
export const httpSubmitToAirbnb = ({urlParams, params}: HttpSubmitToAirbnbOptions) =>
    axios.get(`/assignment/${urlParams.assignmentId}/assets-uploaded`, {params})

/*Host responsive*/
export interface HttpHostResponsiveOptions {
    params: ResponseTypeParam
    urlParams: {assignmentId: number; taskId: number}
}
export const httpHostResponsive = ({urlParams, params}: HttpHostResponsiveOptions) =>
    axios.patch(`/tasks/${urlParams.taskId}/assignments/${urlParams.assignmentId}/coordination/host-responsive`, null, {
        params
    })

/*Coordination*/
export interface HttpAssignmentCoordinationOptions {
    params: ResponseTypeParam
    urlParams: {assignmentId: number; taskId: number}
    payload:
        | {
              status: 'host_is_unresponsive'
              reason_id: number
              notes?: string
          }
        | {
              status: 'host_is_not_ready' | 'photographer_not_available'
              date?: string
          }
        | {
              status: 'dates_dont_match' | 'manual_coordination' | 'host_contacted'
          }
}
export const httpAssignmentCoordination = ({urlParams, params, payload}: HttpAssignmentCoordinationOptions) =>
    axios.patch(`tasks/${urlParams.taskId}/assignments/${urlParams.assignmentId}/coordination`, payload, {params})

/*Chatbot assignments*/
export interface HttpPullChatbotAssignmentsOptions {
    params: {
        statuses: ChatbotAssignmentTaskStatusArray
        filter_by_date: '0' | '1'
    } & ResponseTypeParam
}
export const httpPullChatbotAssignments = ({params}: HttpPullChatbotAssignmentsOptions) => {
    const url = '/assignments'
    return axios.get(url, {
        params: {
            statuses: params.statuses,
            filter_by_date: params.filter_by_date, //0: all shoots in the statuses, 1: shoots that have been in a determined status in the last month
            response_type: params.response_type
        }
    })
}

/*Get spaces*/
interface HttpGetOfferings {
    urlParams: {entityExternalId: string}
    params: {responseType: ResponseType}
}

export const httpGetOfferings = ({urlParams, params}: HttpGetOfferings) => {
    return axiosNode.get(`/v1/services/entities/${urlParams.entityExternalId}/offerings`, {params})
}
